import { SettingsField } from './SettingsField'
import type { AgentMeta } from './agentTypeMetadata'

interface Props {
  agent: AgentMeta
  settings: Record<string, unknown>
  onChange: (settings: Record<string, unknown>) => void
  campaignProductId?: number | null
}

export function SettingsForm({
  agent,
  settings,
  onChange,
  campaignProductId,
}: Props) {
  if (agent.settings_schema.length === 0) return null

  return (
    <div>
      <h4 className="text-xs font-medium uppercase tracking-wide text-fg-secondary">
        Agent Settings
      </h4>
      <div className="mt-3 space-y-4">
        {agent.settings_schema.map((field) => (
          <SettingsField
            key={field.key}
            field={field}
            value={settings[field.key]}
            onChange={(value) => onChange({ ...settings, [field.key]: value })}
            campaignProductId={campaignProductId}
          />
        ))}
      </div>
    </div>
  )
}
